function ListOfficesController($window, $filter, PageHeading, OfficeComponent, Toast) {
	'ngInject';

	const vm = this;
	vm.getOffices = OfficeComponent.getOffices;
	vm.paginationInfo = OfficeComponent.getPaginationInfo();
	vm.loadPage = OfficeComponent.fetchOffices;
	vm.deleteOffice = deleteOffice;
	vm.getExternalUserLink = getExternalUserLink;
	vm.isPaymentSystemRole = isPaymentSystemRole;

	activate();

	function activate() {
		const heading = $filter('translate')('SIDEBAR.OFFICES');
		const title = `BTMS | ${$filter('translate')('SIDEBAR.OFFICES')}`;

		PageHeading.setPageHeading(heading, title);
	}

	function deleteOffice(id) {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			OfficeComponent.deleteOffice(id)
				.then(function(res) {
					if (res.data.errors) {
						Toast.responseError(res.data.errors);
					} else {
						Toast.success($filter('translate')('SUCCESS.DELETE_OFFICE'));
						if (OfficeComponent.getOffices().length === 1 && OfficeComponent.getPaginationInfo().page !== 1) {
							OfficeComponent.fetchOffices(OfficeComponent.getPaginationInfo().page - 1);
						} else {
							OfficeComponent.fetchOffices(OfficeComponent.getPaginationInfo().page);
						}
					}
				});
		}
	}

	function getExternalUserLink(email) {
		const link = $window.location.origin + '/?u=' + email;

		$window.prompt($filter('translate')('USER_LINK_COPY'), link);
	}

	function isPaymentSystemRole(office) {
		let isPaymentRole = false;

		angular.forEach(office.roles, function (role) {
			if (role.name === 'paymentSystem') {
				isPaymentRole = true;
			}
		});

		return isPaymentRole;
	}
}

export default ListOfficesController;



/** WEBPACK FOOTER **
 ** ./client/private/offices/list/list.controller.js
 **/